import React from "react";
import styled from "styled-components";
import SearchBar from "../common/Search/SearchBar";

const HeaderBar = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f9f9f9;
  padding: 12px 40px;
  border-bottom: 1px solid #ddd;
  padding-bottom: 12px;
`;

const Title = styled.div`
  margin-right: 60px;
`;

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 20px;
  font-weight: 500;
`;

const Button = styled.button`
  display: flex;
  align-items: center;
  background-color: #6AB8A8;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 14px;
  margin-left: 10px;
  cursor: pointer;

  span {
    font-size: 14px;
    margin-left: 8px;
  }
`;

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ProfileHeader = () => {
  return (
    <HeaderBar>
      <TitleGroup>
        <Title>
          CADASTRO
        </Title>
      </TitleGroup>

      <SearchWrapper>
        <SearchBar
          placeholder="Pesquisar por campo"
          style={{ backgroundColor: "#fafafa", borderColor: "#ddd" }}
        />
      </SearchWrapper>
    </HeaderBar>
  );
};

export default ProfileHeader;
